import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Premiumcabrentalwithdriveninbanglore() {



  const cardData =
  {
    keyword: 'Premium Cab Rentals with Drivers in Bangalore',
    heading: 'Aaryan Travels: Premium Cab Rentals with Drivers in Bangalore',
    headingDescription: 'Aaryan Travels offers Premium Cab Rentals with Drivers in Bangalore for business travelers, corporate executives, and families who prefer comfort and professionalism on the road. Whether it’s airport transfers from Kempegowda International Airport, office commutes, hotel transfers, or outstation trips to Mysore, Coorg, or Chennai, our fleet of luxury sedans, executive SUVs, and well-maintained vehicles ensures a refined travel experience. With courteous chauffeurs, GPS-enabled cars, and 24/7 availability, we provide seamless and dependable premium cab services across major locations like Whitefield, Electronic City, Koramangala, and Indiranagar. Aaryan Travels delivers a superior travel standard for those who value safety, convenience, and elegance.',

    top: 'Top Places to Visit in Bangalore with Aaryan Travels',

"topPlaces": [
  {
    "title": "Lalbagh Botanical Garden",
    "description": "Lalbagh Botanical Garden is a 240-acre green paradise known for its rare plant species, serene lake, and the iconic Glass House inspired by London’s Crystal Palace. The annual flower show attracts thousands of visitors. Joggers, photographers, and nature lovers frequent its peaceful pathways. Lalbagh is Bangalore’s blooming oasis of tranquility."
  },
  {
    "title": "Bangalore Palace",
    "description": "Bangalore Palace, built in 1878, resembles England’s Windsor Castle with its Tudor-style architecture, wooden interiors, and sprawling gardens. Visitors can explore royal artifacts, paintings, and grand halls. Cultural events and concerts are often hosted on the palace grounds. Bangalore Palace is the city’s majestic symbol of royal heritage."
  },
  {
    "title": "Cubbon Park",
    "description": "Cubbon Park is a lush 300-acre urban park offering wide green lawns, walking trails, and colonial-era statues. Known as the 'lungs of Bangalore', it provides a refreshing escape for joggers, families, and pet lovers. The surrounding library and Vidhana Soudha enhance its scenic charm. Cubbon Park is Bangalore’s evergreen retreat in the city center."
  },
  {
    "title": "ISKCON Temple Bangalore",
    "description": "ISKCON Temple is a grand spiritual complex dedicated to Lord Krishna, featuring gold-plated kalashas and intricate carvings. Daily rituals, kirtans, and prasadam distribution uplift devotees. The in-house Govinda’s restaurant serves delicious sattvic meals. ISKCON Temple is Bangalore’s serene sanctuary of devotion and peace."
  },
  {
    "title": "Nandi Hills",
    "description": "Located about 60 km from the city, Nandi Hills is a popular sunrise viewpoint offering misty landscapes and cool breezes. The 18th-century Tipu Sultan’s Summer Palace adds historical charm. Adventure seekers enjoy cycling and trekking. Clouds often float beneath the hilltop, creating a heavenly experience. Nandi Hills is Bangalore’s scenic escape at dawn."
  },
  {
    "title": "Commercial Street",
    "description": "Commercial Street is Bangalore’s most bustling shopping hub filled with fashion stores, footwear stalls, and jewelry shops. Bargain hunters explore every lane for trendy deals. Street food vendors and vibrant crowds make it lively throughout the day. Commercial Street is Bangalore’s go-to destination for shopping and street vibes."
  },
  {
    "title": "Vidhana Soudha",
    "description": "Vidhana Soudha is Karnataka’s grand legislative building, designed in Neo-Dravidian architecture. Its majestic domes, pillars, and granite facade make it a stunning landmark. Though entry inside is restricted, tourists admire it from outside, especially when illuminated at night. Vidhana Soudha is Bangalore’s architectural pride of governance."
  },
  {
    "title": "UB City",
    "description": "UB City is a luxury commercial complex featuring premium brands, fine-dining restaurants, and rooftop lounges. The European-style architecture and open-air amphitheater host live events regularly. It’s a popular hangout spot for professionals and partygoers. UB City is Bangalore’s hub of luxury and lifestyle."
  },
  {
    "title": "Bannerghatta Biological Park",
    "description": "Bannerghatta Biological Park is a wildlife reserve offering safari rides to spot tigers, lions, and bears in natural habitats. It also includes a butterfly park and a mini zoo. Nature lovers enjoy trekking and photography in the surrounding forests. Bannerghatta is Bangalore’s adventurous encounter with wildlife."
  },
  {
    "title": "MG Road & Brigade Road",
    "description": "MG Road and Brigade Road form the city’s iconic commercial stretch lined with cafes, pubs, bookstores, and fashion outlets. Known for nightlife and cosmopolitan vibes, it’s a favorite hangout for youngsters. During festivals, the streets are lit up beautifully. MG Road is Bangalore’s pulse of urban energy."
  }
],


"services": [
  {
    "name": "Premium Cab Rentals with Drivers in Bangalore",
    "description": "Premium Cab Rentals with Drivers in Bangalore offer luxurious and reliable transportation with professional chauffeurs. Ideal for business trips, corporate travel, and special occasions, our service ensures comfort, safety, and punctuality."
  },
  {
    "name": "Bangalore Premium Car Hire with Driver",
    "description": "Bangalore Premium Car Hire with Driver provides top-tier vehicles and experienced drivers for seamless travel. Whether for corporate clients or personal use, enjoy a premium ride with personalized service and timely pickups."
  },
  {
    "name": "Chauffeur Driven Premium Cab Bangalore",
    "description": "Chauffeur Driven Premium Cab Bangalore features trained chauffeurs delivering discreet and professional service. Perfect for executives and VIPs, our premium cabs combine luxury with efficiency for all your travel needs."
  },
  {
    "name": "Executive Cab Bangalore",
    "description": "Executive Cab Bangalore offers high-end cars and exceptional service for business professionals. With amenities designed for comfort and productivity, this service is perfect for meetings, airport transfers, and corporate events."
  },
  {
    "name": "Luxury Cab Hire Bangalore",
    "description": "Luxury Cab Hire Bangalore provides premium vehicles equipped with modern features like leather interiors and climate control. Ideal for VIP clients, weddings, and special occasions, we ensure a stylish and comfortable journey."
  },
  {
    "name": "Corporate Premium Cab Bangalore",
    "description": "Corporate Premium Cab Bangalore caters to business clients requiring dependable and upscale transportation. Our service includes customized plans, professional drivers, and timely service to support corporate travel needs."
  },
  {
    "name": "Staff Cab Hire Bangalore",
    "description": "Staff Cab Hire Bangalore offers safe and punctual transportation solutions for employee commutes. Our monthly and long-term plans provide reliable rides with well-maintained vehicles and trained drivers."
  },
  {
    "name": "Monthly Premium Cab Bangalore",
    "description": "Monthly Premium Cab Bangalore delivers cost-effective and premium transportation on a subscription basis. Ideal for businesses and frequent travelers, enjoy consistent service and flexible plans tailored to your needs."
  },
  {
    "name": "Sedan Premium Cab Bangalore",
    "description": "Sedan Premium Cab Bangalore features sleek and comfortable sedans suitable for business and personal travel. With professional drivers and modern amenities, we ensure a smooth and stylish ride every time."
  },
  {
    "name": "SUV Premium Cab Bangalore",
    "description": "SUV Premium Cab Bangalore offers spacious and luxurious SUVs for group travel and clients with extra luggage. Our SUVs come with enhanced safety features and are driven by experienced chauffeurs for maximum comfort."
  },
  {
    "name": "Best Premium Cab Bangalore",
    "description": "Best Premium Cab Bangalore is recognized for outstanding service, punctuality, and a premium fleet. We pride ourselves on delivering the highest standards of corporate and luxury transportation across the city."
  },
  {
    "name": "Affordable Premium Cab Bangalore",
    "description": "Affordable Premium Cab Bangalore combines luxury with budget-friendly pricing. Perfect for cost-conscious travelers who seek quality and reliability without compromising on comfort."
  },
  {
    "name": "Online Premium Cab Booking Bangalore",
    "description": "Online Premium Cab Booking Bangalore offers an easy-to-use platform to book premium cabs anytime. Get instant confirmations, transparent pricing, and real-time tracking for all your luxury rides."
  },
  {
    "name": "Premium Chauffeur Bangalore",
    "description": "Premium Chauffeur Bangalore provides professional and discreet chauffeurs trained to deliver exceptional service. Ideal for executives, VIPs, and special occasions requiring top-tier transport."
  },
  {
    "name": "Bangalore Prestige Cab",
    "description": "Bangalore Prestige Cab delivers exclusive and luxurious transportation experiences. Featuring a fleet of prestige vehicles and dedicated chauffeurs, we cater to discerning clients looking for the best in comfort and style."
  }
],
"tableData": [
  ["Premium Cab Rentals with Drivers in Bangalore", "Bangalore Premium Car Hire with Driver"],
  ["Chauffeur Driven Premium Cab Bangalore", "Executive Cab Bangalore"],
  ["Luxury Cab Hire Bangalore", "Corporate Premium Cab Bangalore"],
  ["Staff Cab Hire Bangalore", "Monthly Premium Cab Bangalore"],
  ["Sedan Premium Cab Bangalore", "SUV Premium Cab Bangalore"],
  ["Best Premium Cab Bangalore", "Affordable Premium Cab Bangalore"],
  ["Online Premium Cab Booking Bangalore", "Premium Chauffeur Bangalore"],
  ["Bangalore Prestige Cab", "—"]
],

"whychoose": [
  {
    "WhyChooseheading": "Premium Cab Rentals with Drivers in Bangalore",
    "WhyChoosedescription": "Aaryan Travels offers premium cab rental services with professional drivers in Bangalore for a luxurious travel experience."
  },
  {
    "WhyChooseheading": "Trained and Courteous Chauffeurs",
    "WhyChoosedescription": "Our experienced drivers ensure punctual, polite, and professional service for every ride."
  },
  {
    "WhyChooseheading": "High-Quality, Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in clean, air-conditioned, and regularly serviced premium cars for maximum comfort and safety."
  },
  {
    "WhyChooseheading": "Drivers Familiar with Bangalore Routes",
    "WhyChoosedescription": "Our drivers have extensive knowledge of Bangalore’s roads and traffic, ensuring efficient travel."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "Enjoy clear, upfront pricing with no hidden costs—what you see is what you pay."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Seamless Assistance",
    "WhyChoosedescription": "Our dedicated support team is always available to assist with bookings, changes, or inquiries."
  },
  {
    "WhyChooseheading": "Flexible Rental Durations",
    "WhyChoosedescription": "Choose from hourly, daily, or long-term rentals based on your travel needs and schedule."
  },
  {
    "WhyChooseheading": "Wide Range of Premium Vehicles",
    "WhyChoosedescription": "Select from sedans, SUVs, and luxury cars to suit your personal or professional preferences."
  }
]








































  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer premium cab rentals with drivers in Bangalore?',
    answer: 'Yes, Aaryan Travels provides top-quality premium cab rentals with professional drivers in Bangalore for a smooth and luxurious experience.',
  },
  {
    question: 'How can I book premium cab rentals with drivers in Bangalore?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team.',
  },
  {
    question: 'What types of premium vehicles are available for rentals in Bangalore?',
    answer: 'Aaryan Travels offers a range of premium vehicles including sedans, SUVs, and executive-class cars with trained chauffeurs.',
  },
  {
    question: 'Are drivers professionally trained for premium cab services in Bangalore?',
    answer: 'Absolutely. All our drivers are licensed, well-groomed, and trained to offer courteous and professional service.',
  },
  {
    question: 'Can I rent a premium cab with a driver for outstation travel from Bangalore?',
    answer: 'Yes, Aaryan Travels allows premium cab rentals with drivers for both local and outstation travel from Bangalore.',
  },
  {
    question: 'Is the premium cab rental service with drivers available 24x7 in Bangalore?',
    answer: 'Yes, our premium cab rental services with drivers are available round-the-clock to suit your schedule.',
  },
  {
    question: 'Are safety and hygiene protocols followed in premium cab rentals?',
    answer: 'All vehicles are sanitized before every ride, and our drivers follow strict hygiene and safety guidelines.',
  },
  {
    question: 'What payment options are accepted for premium cab rentals in Bangalore?',
    answer: 'We accept cash, digital wallets, UPI, and card payments for your convenience.',
  },
  {
    question: 'Is customer support available during premium cab rental rides in Bangalore?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your rental experience.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Kiran Nair',
    feedback: 'Aaryan Travels provided a premium cab with a professional driver in Bangalore — seamless service and great comfort!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Shruti Menon',
    feedback: 'Booked a premium cab rental with driver in Bangalore through Aaryan Travels — the ride was luxurious and the driver was very courteous.',
    rating: 5,
  },
];
























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];






const premiumCabBangaloreSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Premium Cab Rentals with Drivers in Bangalore",
  "description": "Aaryan Travels offers premium cab rentals with professional drivers in Bangalore including luxury sedans and SUVs for corporate, staff, and executive transportation.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Bangalore"
  },
  "serviceType": "Premium Cab Rental with Driver",
  "keywords": "Premium Cab Rentals with Drivers in Bangalore, Bangalore Premium Car Hire with Driver, Chauffeur Driven Premium Cab Bangalore, Executive Cab Bangalore, Luxury Cab Hire Bangalore, Corporate Premium Cab Bangalore, Staff Cab Hire Bangalore, Monthly Premium Cab Bangalore, Sedan Premium Cab Bangalore, SUV Premium Cab Bangalore, Best Premium Cab Bangalore, Affordable Premium Cab Bangalore, Online Premium Cab Booking Bangalore, Premium Chauffeur Bangalore, Bangalore Prestige Cab"
};







  return (
    <div>


<Helmet>
  <title>Premium Cab Rentals with Drivers in Bangalore | Luxury Chauffeur Cabs | Aaryan Travels</title>
  <meta
    name="description"
    content="Book premium cab rentals with drivers in Bangalore from Aaryan Travels. Luxury sedans, SUVs, executive and corporate chauffeur-driven cabs available."
  />
  <meta
    name="keywords"
    content="Premium Cab Rentals with Drivers in Bangalore, Bangalore Premium Car Hire with Driver, Chauffeur Driven Premium Cab Bangalore, Executive Cab Bangalore, Luxury Cab Hire Bangalore, Corporate Premium Cab Bangalore, Staff Cab Hire Bangalore, Monthly Premium Cab Bangalore, Sedan Premium Cab Bangalore, SUV Premium Cab Bangalore, Best Premium Cab Bangalore, Affordable Premium Cab Bangalore, Online Premium Cab Booking Bangalore, Premium Chauffeur Bangalore, Bangalore Prestige Cab"
  />
  <script type="application/ld+json">
    {JSON.stringify(premiumCabBangaloreSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/59.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Premiumcabrentalwithdriveninbanglore;